import Axios from 'axios'
import {
    CREATE,
    CREATE_FAILED,
    CREATE_SUCCESSFUL,

}  from '../constant/Create'
const BASE_URL = process.env.REACT_APP_BASE_URL;
// console.log(BASE_URL)

// export const createaccounts = (user, company) => async (dispatch) => {
//     dispatch({
//         type: CREATE
//     })

//     console.log({ "user": {...user},
//     "company": {...company}})
//     try {
//         const { data } = await Axios.post(`${BASE_URL}/company/user-company/create`, {

           
//         // "user": {
//         //     "first_name":firstName ,
//         //     "last_name": lastName,
//         //     "email": email,
//         //     "phone_number": phoneNumber,
//         //     "password": password,
//         //     "category": 'company'
//         // },
//         // "company": {
//         //     "name": 'companyName',
//         //     "company_email": 'companyEmail',
//         //     "company_size":'companySize',
//         //     "industry":'Industry',
//         //     "rc_number": 'rc',
//         //     "incorporation_date": 'date'
//         // }
//         "user": user,
//         "company": company
        
//         }
//     //     ,
//     //      {
//     //         headers: {
//     //             "Content-Type": "application/json" // Set the content type header
//     // }}
//     )
        

//         dispatch({
//             type:CREATE_SUCCESSFUL,
//             payload: data
//         })
//         console.log(data)

//     }
//     catch (error) {
//         dispatch({
//             type: CREATE_FAILED,
//             payload: error
//         })

//         console.log(error)
//     }
// }





export const createaccounts = (user, company) => async (dispatch) => {
    dispatch({
        type: CREATE
    })
    console.log(user)
    console.log(company)

    // console.log({
    //     "user": {
    //         "first_name": user.first_name,
    //         "last_name": user.last_name,
    //         "email": user.email,
    //         "phone_number": user.phone_number,
    //         "password": user.password,
    //         "category": user.category,
    //     },
    //     "company": {
    //         "name": company.name,
    //         "company_email": user.company_email,
    //         "company_size": user.company_size,
    //         "industry": user.industry,
    //         "rc_number": user.rc_number,
    //         "incorporation_date": user.incorporation_date,
    //     }
    // })

    console.log(  {      "user": {
        "first_name": user.first_name,
        "last_name": user.last_name,
        "email": user.email,
        "phone_number": user.phone_number,
        "password": user.password,
        "category": user.category,
    },
    "company": {
        "name": company.name,
        "company_email": company.company_email,
        "company_size": company.company_size,
        "industry": company.industry,
        "rc_number": company.rc_number,
        "incorporation_date": company.incorporation_date,
    }})
    try {
        const { data } = await Axios.post(`${BASE_URL}/company/user-company/create`, {

           
        // "user": {
        //     "first_name":firstName ,
        //     "last_name": lastName,
        //     "email": email,
        //     "phone_number": phoneNumber,
        //     "password": password,
        //     "category": 'company'
        // },
        // "company": {
        //     "name": 'companyName',
        //     "company_email": 'companyEmail',
        //     "company_size":'companySize',
        //     "industry":'Industry',
        //     "rc_number": 'rc',
        //     "incorporation_date": 'date'
        // }
        "user": {
            "first_name": user.first_name,
            "last_name": user.last_name,
            "email": user.email,
            "phone_number": user.phone_number,
            "password": user.password,
            "category": user.category,
        },
        "company": {
            "name": company.name,
            "company_email": company.company_email,
            "company_size": company.company_size,
            "industry": 'information_technology',
            "rc_number": company.rc_number,
            "incorporation_date": company.incorporation_date,
        }
        
        },
        {
            headers: {
                "Content-Type": "application/json" // Set the content type header
            }
        }
    )
        

        dispatch({
            type:CREATE_SUCCESSFUL,
            payload: data
        })
        console.log(data)

    }
    catch (error) {
        dispatch({
            type: CREATE_FAILED,
            payload: error
        })

        console.log(error)
    }
}